import dynamic from 'next/dynamic';
import A from './components/A';
import FixTab from './components/FixTab';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export default function TheProduct({ systemTime }: any) {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div className={`amazon-sale ${css['amazon-sale']}`}>
            <A systemTime={systemTime} />
            <FixTab />
            <IndexDynamic />
        </div>
    );
}
